export const SET_SIDENAV_SETTINGS = 'SET_SIDENAV_SETTINGS'
export const SET_IS_OPEN = 'SET_IS_OPEN'
export const UPDATE_HEADER_STATE = 'UPDATE_HEADER_STATE'
export const SET_PATH_CHECK = 'SET_PATH_CHECK'
export const CLEAR_LAYOUT = 'CLEAR_LAYOUT'
export const SET_PRODUCTS_ATTRIBUTES_VIEW = 'SET_PRODUCTS_ATTRIBUTES_VIEW'
export const SET_NOTIFICATION_OPEN = 'SET_NOTIFICATION_OPEN'
export const SET_SIDENAV_HOVER_SETTINGS = 'SET_SIDENAV_HOVER_SETTINGS'
export const SET_ALL_SIDENAV_SETTINGS = 'SET_ALL_SIDENAV_SETTINGS'
export const SET_THEME = 'SET_THEME'

const actions = {
  setNotificationOpen: (state) => (dispatch) => {
    dispatch({
      type: SET_NOTIFICATION_OPEN,
      payload: state
    })
  },
  setProductsAttributesView: (state) => (dispatch) => {
    dispatch({
      type: SET_PRODUCTS_ATTRIBUTES_VIEW,
      payload: state
    })
  },
  sideNavChange: (state) => (dispatch, getState) => {
    const isOpen = getState().layout.settings?.layoutSettings?.sidebar?.open
    dispatch({
      type: SET_SIDENAV_SETTINGS,
      payload: state !== undefined ? state : !isOpen
    })
  },
  hoverNavChange: (state) => (dispatch) => {
    dispatch({
      type: SET_SIDENAV_HOVER_SETTINGS,
      payload: state
    })
  },
  allNavChange: (state) => (dispatch, getState) => {
    const isOpen = getState().layout.settings?.layoutSettings?.sidebar?.open && getState().layout.settings?.layoutSettings?.sidebar?.hover
    dispatch({
      type: SET_ALL_SIDENAV_SETTINGS,
      payload: state !== undefined? state : !isOpen
    })
  },
  setIsOpen: (state) => (dispatch) => {
    dispatch({
      type: SET_IS_OPEN,
      payload: state
    })
  },
  updateHeaderState: (state) => (dispatch) => {
    dispatch({
      type: UPDATE_HEADER_STATE,
      payload: state
    })
  },
  setPathCheck: (state) => (dispatch) => {
    dispatch({
      type: SET_PATH_CHECK,
      payload: state
    })
  },
  clearLayout: () => (dispatch) => {
    dispatch({
      type: CLEAR_LAYOUT
    })
  },
  setTheme: (theme) => (dispatch) => {
    dispatch({
      type: SET_THEME,
      payload: theme
    })
  },
}

export default actions